module.exports = __webpack_public_path__ + "static/media/ic_manual_billing.f0e3f3b9.svg";